import {
  Dimensions,
  FlatList,
  NativeScrollEvent,
  NativeSyntheticEvent,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import React, { useState } from "react";

import DNECard from "./Cards/DNECard";
import StudentCard from "./Cards/StudentCard";
import DNEBack from "./Cards/DNEBack";
import TopCardsBar from "./TopCardsBar";
import { usePreventScreenCapture } from "expo-screen-capture";

const WIDTH = Dimensions.get("screen").width;
console.log(WIDTH)
const Cards = () => {
  usePreventScreenCapture();
  const [activePage, setActivePage] = useState(1);
  const handleScroll = (e: NativeSyntheticEvent<NativeScrollEvent>) => {
    let contentOffset = e.nativeEvent.contentOffset;
    let viewSize = e.nativeEvent.layoutMeasurement;
    setActivePage(Math.floor(contentOffset.x / viewSize.width) + 1);
  };
  const slides = [1, 2, 3];
  return (
    <View style={styles.root}>
      <TopCardsBar />
      <FlatList
        data={slides}
        keyExtractor={(item) => item.toString()}
        style={styles.flatList}
        horizontal
        snapToAlignment={"start"}
        decelerationRate={"normal"}
        snapToInterval={WIDTH}
        pagingEnabled
        onScroll={handleScroll}
        showsHorizontalScrollIndicator={false}
        renderItem={({ item }) => {
          return (
            <View style={styles.card}>
              {item === 1 ? (
                <StudentCard />
              ) : item === 2 ? (
                <DNECard />
              ) : (
                <DNEBack />
              )}
            </View>
          );
        }}
      />
      <View style={styles.bullets}>
        {slides.map((slide) => {
          return (
            <View
              key={slide}
              style={[
                styles.bullet,
                { opacity: slide === activePage ? 1 : 0.5 },
              ]}
            />
          );
        })}
      </View>
    </View>
  );
};

export default Cards;

const styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  flatList: { width: "100%" },
  card: {
    width: WIDTH,
  },
  bullets: {
    marginBottom: 90,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  bullet: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#fff",
    marginHorizontal: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
});
